import { create } from '@wix/fedops-logger';

// NOTE: https://github.com/wix-private/fed-infra/tree/master/fedops/fedops-logger
const fedopsLogger = create('podcasts-widget');

export { fedopsLogger };
